import React from 'react';
import { observer } from 'mobx-react';
import { computed, observable } from 'mobx';
import { isPresent } from '@seedlang/utils';
import { ConceptWordStore } from '@seedlang/stores';
import InPlaceSelect from 'components/form/in_place_select';
import Stack from 'components/layout/stack';
import ButtonPrimary from 'components/button/button_primary';

@observer
class ConceptBatchAddWords extends React.Component {
  @observable wordTypeId = this.props.wordTypeId;

  @computed get wordTypeName() {
    if (this.wordTypeId) {
      return this.props.wordTypes.find(item => item.id === this.wordTypeId).name;
    }
    return null;
  }

  @computed get placeholder() {
    if (this.wordTypeId) {
      return `Add ${this.wordTypeName}s (word1,word2,word3)`;
    } else {
      return 'Add Words (word1,word2,word3)';
    }
  }

  onClick() {
    if (isPresent(this.refs.targetTexts.value)) {
      ConceptWordStore.create(
        {
          data: {
            target_texts: this.refs.targetTexts.value,
            concept_id: this.props.conceptId,
            word_params: {
              root: true,
              word_type_id: this.wordTypeId,
            },
          },
        },
      this.props.afterCreate);
      this.refs.targetTexts.value = '';
    }
  }

  render() {
    return (
      <Stack gap='sm' alignItems='stretch'>
        <InPlaceSelect
          options={this.props.wordTypes.map(item => [item.id, item.name])}
          includeBlank='true'
          onChange={val => this.wordTypeId = val}
          placeholder='Select a Word Type'
          value={this.wordTypeId}
        />
        <textarea
          height='150px'
          placeholder={this.placeholder}
          ref='targetTexts'
        />
        <ButtonPrimary onClick={this.onClick.bind(this)}>
          Create
        </ButtonPrimary>
      </Stack>
    );
  }
}

export default ConceptBatchAddWords;
